import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        height: '100vh'
    },
    content: {
        textAlign: 'center',
    },
    image: {
        width: 400
    },
    gridImage: {
        textAlign: 'center',
        paddingTop: 50,
    },
}))
